import Vue from 'vue'
import VueI18n from 'vue-i18n'
import CONFIG from '~config/env'
import ptBr from '~src/i18n/pt-br.json'

const availableLangagues = [CONFIG.DEFAULT_LANGUAGE, 'en', 'es']
const loadedLanguages = [CONFIG.DEFAULT_LANGUAGE]

Vue.use(VueI18n)
const defaultMesages = {}
defaultMesages[CONFIG.DEFAULT_LANGUAGE] = ptBr

const i18n = new VueI18n({
  locale: CONFIG.DEFAULT_LANGUAGE,
  messages: defaultMesages,
  missing: function (locale, path) {
    console.warn('Missing translation: ' + locale + ' - ' + path)
  }
})

const detectLanguage = () => {
  const userLang = navigator.language || navigator.userLanguage

  if (!userLang || userLang === 'pt') {
    return CONFIG.DEFAULT_LANGUAGE
  }

  return userLang
}

const setupLanguage = async newLanguage => {
  newLanguage = 'pt' // newLanguage || detectLanguage()
  if (i18n.locale !== newLanguage) {
    if (!loadedLanguages.includes(newLanguage) && availableLangagues.includes(newLanguage)) {
      const messages = await import('~src/i18n/' + newLanguage + '.json')

      if (messages) {
        i18n.setLocaleMessage(newLanguage, messages)
        loadedLanguages.push(newLanguage)
        i18n.locale = newLanguage
      }
    } else if (availableLangagues.includes(newLanguage)) {
      i18n.locale = newLanguage
    }
  }
  Vue.moment.locale(newLanguage)
}

const localeString = stringsArr => {
  if (!Array.isArray(stringsArr)) {
    return stringsArr
  }

  stringsArr.forEach(str => {
    if (str.lang === i18n.locale) {
      return str.value
    }
  })

  return stringsArr[0].value || ''
}

Object.defineProperty(Vue, 'localeString', {
  get: () => {
    return localeString
  }
})

Object.defineProperty(Vue.prototype, '$localeString', {
  get: () => {
    return localeString
  }
})

export { i18n, setupLanguage, detectLanguage }
